import { useContext } from 'react';
import { InstantSearchRSCContext } from './InstantSearchRSCContext.js';

function useRSCContext() {
    return useContext(InstantSearchRSCContext);
}

export { useRSCContext };
